import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PlatformUser } from '@/types/platform';

interface SuperAdminAuthState {
  token: string | null;
  platformUser: PlatformUser | null;
  isAuthenticated: boolean;
  impersonation: {
    isImpersonating: boolean;
    sessionId?: string;
    targetSocietyName?: string;
    targetSocietyId?: string;
    reason?: string;
  } | null;
  setPlatformAuth: (token: string, user: PlatformUser) => void;
  clearPlatformAuth: () => void;
  setImpersonation: (data: {
    sessionId: string;
    targetSocietyName: string;
    targetSocietyId: string;
    reason: string;
  }) => void;
  clearImpersonation: () => void;
}

export const useSuperAdminAuthStore = create<SuperAdminAuthState>()(
  persist(
    (set) => ({
      token: null,
      platformUser: null,
      isAuthenticated: false,
      impersonation: null,
      setPlatformAuth: (token, user) =>
        set({
          token,
          platformUser: user,
          isAuthenticated: true,
        }),
      clearPlatformAuth: () =>
        set({
          token: null,
          platformUser: null,
          isAuthenticated: false,
          impersonation: null,
        }),
      setImpersonation: (data) =>
        set({
          impersonation: {
            isImpersonating: true,
            sessionId: data.sessionId,
            targetSocietyName: data.targetSocietyName,
            targetSocietyId: data.targetSocietyId,
            reason: data.reason,
          },
        }),
      clearImpersonation: () =>
        set({
          impersonation: null,
        }),
    }),
    {
      name: 'apnablock-platform-auth',
    },
  ),
);
